var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',{attrs:{"color":"blue-grey darken-4","acolor":"#2B3848","dark":""}},[_c('v-toolbar-title',{staticClass:"mr-4"},[_vm._v(_vm._s(_vm.model))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }